import React from 'react';
import { styled, keyframes } from '@mui/system';

const moveDot = keyframes`
  0%, 100% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(110%, -55%);
  }
  50% {
    transform: translate(110%, +55%);
  }
  75% {
    transform: translate(0%, 110%);
  }
`;

const SpinnerContainer = styled('div')({
  width: '6rem',
  height: '6rem',
  position: 'relative',
  transform: "translate(-25%, -55%);",
});

const Dot = styled('div')(({ theme, color }) => ({
  width: '3rem',
  height: '3rem',
  backgroundColor: color,
  borderRadius: '10px',
  position: 'absolute',
  margin: 'auto',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  animation: `${moveDot} 4s infinite`,
  '&:nth-of-type(1)': {
    animationDelay: '0s',
  },
  '&:nth-of-type(2)': {
    animationDelay: '1s',
  },
  '&:nth-of-type(3)': {
    animationDelay: '2s',
  },
  '&:nth-of-type(4)': {
    animationDelay: '3s',
  },
}));

const CasablancaSpinner: React.FC = () => {
  const colors = ['#41698A', '#889245',  '#E7B311', '#002C4A']; // Blue, Green, Yellow, Dark blue

  return (
    <SpinnerContainer>
      {colors.map((color, index) => (
        <Dot key={index} color={color} />
      ))}
    </SpinnerContainer>
  );
};

export default CasablancaSpinner;
